import _URL from '../../URL/index';
const axios = _URL.axios;

export default {
    services: {
        exportCSVCustomers: (body, token) => {
            return axios(token).post(`/export/customers`, body);
        },
        exportCSVServices: (body, token) => {
            return axios(token).post(`/export/services`, body);
        },
        exportCSVCompanies: (body, token) => {
            return axios(token).post(`/export/companies`, body);
        },
        exportCSVBranches: (supplierId, payment, token = "") => {
            return axios(token).post(`/export/suppliers/${supplierId}/destinations`, payment);
        },
        exportCSVOperators: (body, token) => {
            return axios(token).post(`/export/operators`, body);
        },
        exportCSVReservations: (body, token) => {
            return axios(token).post(`/export/reservations`, body);
        },
        exportCSVReservationsAll: (token) => {
            return axios(token).get(`/export/reservations/all`);
        },
        exportCSVReservationsAllSearch: (query, token) => {
            return axios(token).get(`/export/reservations/all/search/advanced?${query}`);
        },
        exportCSVReservationsAllQuery: (query, token) => {
            return axios(token).get(`/export/reservations/all/search?search=${query}`);
        },
        exportCSVAreas: (body, token) => {
            return axios(token).post(`/export/areas`, body);
        },
        exportCSVUsers: (body, token) => {
            return axios(token).post(`/export/users`, body);
        },
    }
}